import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/pdf-image-v2.0.0'

export default reactNode(
	'PdfImage',
	{
		'v2.0.0': v200,
	},
	{ docs: '' }
)
